import { FiltroAdminServicios, Servicio, SolicitudAdminServicio } from "../modelo/AdminServicio";

export const CONSULTAR_SERVICIOS = "CONSULTAR_SERVICIOS";
export const SERVICIOS_CONSULTADOS = "SERVICIOS_CONSULTADOS";
export const ERROR_CONSULTANDO_SERVICIOS = "ERROR_CONSULTANDO_SERVICIOS";

export const GESTIONAR_SERVICIO = "GESTIONAR_SERVICIO";
export const GESTION_EXITO = "GESTION_EXITO";
export const GESTION_ERROR = "GESTION_ERROR";
export const LIMPIAR_MENSAJES_SERVICIO = "LIMPIAR_MENSAJES_SERVICIO";

export const VENTANA_AYUDA_SERVICIO = "VENTANA_AYUDA_SERVICIO";

export const consultarServicios = (filtro: FiltroAdminServicios) => ({ type: CONSULTAR_SERVICIOS, filtro});
export const serviciosConsultados = (datosEntidad: Array<Servicio>, paginas: number, totalDatos: number) => ({ 
    type: SERVICIOS_CONSULTADOS, datosEntidad, paginas, totalDatos });
export const errorConsultandoServicios = () => ({ type: ERROR_CONSULTANDO_SERVICIOS });

export const gestionarServicio = (solicitud: SolicitudAdminServicio) => ({ type: GESTIONAR_SERVICIO, solicitud});
export const gestionExito = () => ({ type: GESTION_EXITO});
export const gestionError = (mensaje: string) => ({ type: GESTION_ERROR, mensaje});
export const limpiarMensajesServicio = () => ({type: LIMPIAR_MENSAJES_SERVICIO});

export const ventanaAyudaServicio = () => ({type: VENTANA_AYUDA_SERVICIO});





// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/modulos/adminServicioActions.ts